import { createFileRoute } from '@tanstack/react-router'
import { EntryDetailPage } from '@/features/accounting/entry-detail-page'
import { requirePermission } from '@/lib/route-guards'

/** Detalle de una partida contable con sus líneas y su origen. */
export const Route = createFileRoute('/_app/accounting/entries/$entryId')({
  beforeLoad: requirePermission('accounting:read'),
  component: EntryDetailRoute,
})

function EntryDetailRoute() {
  const { entryId } = Route.useParams()
  return <EntryDetailPage entryId={entryId} />
}
